import {
  ADD_TO_CART,
  REMOVE_ALL_FROM_CART,
  REMOVE_FROM_CART,
} from "../constants";

// Reducer to handle cart data in the Redux store
export const cartData = (data = [], action) => {
  switch (action.type) {
    case ADD_TO_CART:
      // Add the new item to the beginning of the cart array
      return [action.data, ...data];

    case REMOVE_FROM_CART:
      // Find the index of the item to be removed
      const index = data.findIndex((item) => item.id === action.data);
      // If the item is found, create a new array without that item
      if (index !== -1) {
        const updatedCart = [...data];
        updatedCart.splice(index, 1);
        return updatedCart;
      }
      return data;

    case REMOVE_ALL_FROM_CART:
      // Clear the cart by returning an empty array
      data = [];
      return [...data];

    default:
      return data;
  }
};
